import { RootState, AppThunk } from '../../../store'
import { getTrainerPending, getTrainerSuccess, getTrainerFailure } from '.'
import { TrainerServiceTrainer, FetchTrainerType } from '../onDemandWorkouts'
import configuration from '../../../../configuration'
import { request } from '../../../../common/utility/fetch'

const fetchTrainer = async (
  args: FetchTrainerType,
): Promise<TrainerServiceTrainer> => {
  const baseUrl = configuration.trainerServiceApi
  const endpoint = `/api/v1/trainers?emailPrefix=${args.emailPrefix}`
  const method = 'GET'
  const { authToken } = args
  const response = await request({
    baseUrl,
    endpoint,
    method,
    authToken,
  })
  const data = await response.json()

  return response.ok
    ? (data as TrainerServiceTrainer)
    : Promise.reject(new Error(data.error))
}

export const getTrainer =
  (emailPrefix: string): AppThunk =>
  async (dispatch, getState) => {
    const state = getState() as RootState
    const authToken = state.auth?.user?.auth_token
    dispatch(getTrainerPending(true))
    try {
      const response = await fetchTrainer({ emailPrefix, authToken })
      dispatch(getTrainerSuccess(response))
    } catch (error: any) {
      dispatch(getTrainerFailure(error.toString()))
    }
  }
